import loadMore from './loadmore'
const directives = {
    loadMore,
}
 
export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
        })
    },
}